import React from "react";
import cx from "classnames";

import type { BetSelection } from "@/features/betslip/types";
import { isSemSelection } from "@/features/betslip/utils/typeGuards";
import { MultiLegRow } from "@/features/betslip/components/parts/MultiLegRow";
import { MultiLegAlert } from "@/features/betslip/components/parts/MultiLegAlert";
import { SemSubCard } from "@/features/betslip/components/multi/SemSubCard";

import * as styles from "@/features/betslip/components/multi/MultiLegOption.module.scss";

type MultiLegOptionProps = {
  bet: BetSelection;
  radio: React.ReactNode;
  // This leg is the one currently picked for its event's multi slot.
  isPicked: boolean;
  // The event group is live in the multi (not deactivated).
  isSelected: boolean;
  // Show the per-leg alert. Suppressed while the group is blocked, where the
  // group-level "not available" alert already explains why.
  showAlert: boolean;
};

/**
 * One selectable leg of a multi event group: its per-leg alert plus the row (a
 * single) or sub-card (a SEM), wrapped as a radio option. A SEM carries its own
 * selected indicator, so it shows whenever picked; a single's green outline
 * drops while the group is deactivated, where it would only read as dimmed.
 */
export const MultiLegOption = ({
  bet,
  radio,
  isPicked,
  isSelected,
  showAlert,
}: MultiLegOptionProps) => (
  <>
    {showAlert && <MultiLegAlert outcomeId={bet.outcomeId} />}
    {isSemSelection(bet) ? (
      <div className={styles.option}>
        <SemSubCard sem={bet} radio={radio} isSelected={isPicked} />
      </div>
    ) : (
      <div
        className={cx(styles.option, {
          [styles.optionSelected]: isPicked && isSelected,
        })}
      >
        <MultiLegRow bet={bet} radio={radio} />
      </div>
    )}
  </>
);
